import { RouteObject } from "react-router-dom";
import { ProductOfferingConfigsComparePage } from "src/routes/developments/product-offering-configs/ProductOfferingConfigsComparePage";
import { ProductOfferingConfigsPage } from "src/routes/developments/product-offering-configs/ProductOfferingConfigsPage";
import { ProductOfferingApplyToProjectsPage } from "src/routes/developments/product-offerings/ProductOfferingApplyToProjectsPage";
import { ProductOfferingConfigsPage as ProductOfferingSpecificConfigsPage } from "src/routes/developments/product-offerings/ProductOfferingConfigsPage";
import { ProductOfferingPage } from "src/routes/developments/product-offerings/ProductOfferingPage";
import { ProductOfferingsPage } from "src/routes/developments/product-offerings/ProductOfferingsPage";
import { ProductOfferingVersionHistoryPage } from "src/routes/developments/product-offerings/version-history/ProductOfferingVersionHistoryPage";
import * as productOfferingsPaths from "src/routing/domains/developments/product-offerings/productOfferingsPaths";

/**
 * SideNav leaf routes for development product-offerings section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentSideNavLayout` in `detail/developmentDetail.ts`.
 */
export const productOfferingsSideNavRoutes: RouteObject[] = [
  {
    path: productOfferingsPaths.developmentProductOfferingVersionHistoryRoute.path,
    Component: ProductOfferingVersionHistoryPage,
  },
  {
    path: productOfferingsPaths.developmentProductOfferingSpecificConfigsRoute.path,
    Component: ProductOfferingSpecificConfigsPage,
  },
  { path: productOfferingsPaths.developmentProductOfferingOptionalPath, Component: ProductOfferingPage },
  { path: productOfferingsPaths.developmentProductOfferingsRoute.path, Component: ProductOfferingsPage },
  { path: productOfferingsPaths.developmentProductOfferingConfigsRoute.path, Component: ProductOfferingConfigsPage },
  {
    path: productOfferingsPaths.developmentProductOfferingSpecificConfigsCompareRoute.path,
    Component: ProductOfferingConfigsComparePage,
  },
  {
    path: productOfferingsPaths.developmentProductOfferingConfigsCompareRoute.path,
    Component: ProductOfferingConfigsComparePage,
  },
  {
    path: productOfferingsPaths.developmentProductOfferingApplyToProjectRoute.path,
    Component: ProductOfferingApplyToProjectsPage,
  },
];
